/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectApplicationRejectDto
 */
export interface ProjectApplicationRejectDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectApplicationRejectDto
     */
    applicationType: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectApplicationRejectDto
     */
    rejectedNote: string;
}

/**
 * Check if a given object implements the ProjectApplicationRejectDto interface.
 */
export function instanceOfProjectApplicationRejectDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "applicationType" in value;
    isInstance = isInstance && "rejectedNote" in value;

    return isInstance;
}

export function ProjectApplicationRejectDtoFromJSON(json: any): ProjectApplicationRejectDto {
    return ProjectApplicationRejectDtoFromJSONTyped(json, false);
}

export function ProjectApplicationRejectDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectApplicationRejectDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'applicationType': json['applicationType'],
        'rejectedNote': json['rejectedNote'],
    };
}

export function ProjectApplicationRejectDtoToJSON(value?: ProjectApplicationRejectDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'applicationType': value.applicationType,
        'rejectedNote': value.rejectedNote,
    };
}

